import React from "react";

import { Typography } from "@mui/material";

/**
 * The small bold label above each block of a bulletin — Entities, Time(s), Location(s), Narrative.
 *
 * One definition rather than four `Typography` calls that drift: the blocks below these headings are
 * owned by different modules (`entities/` renders its own list, `DisplayAlert` renders the rest), and
 * before this they were a `subtitle1` bold prefix, an `h6` and no heading at all in the same column.
 *
 * The top margin belongs to the heading, not to the block above it. Sections are added and reordered
 * far more often than this file changes, and a heading that carries its own space cannot leave a
 * doubled gap behind when the block above it is removed.
 */
export const BulletinSectionHeading: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 3, mb: 1 }}>
    {children}
  </Typography>
);
